exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* Sidebar background color */\n/* Sidebar header and footer color */\n/* Sidebar title text colour */\n/* Sidebar menu item hover color */\n.texts-danger {\n  color: #F68C1F; }\n\n.texts-success {\n  color: #00A85F; }\n\n.text-stop {\n  color: #ED1C24; }\n\n.no-authorized-template.no-modal {\n  font-size: 1.2em; }\n\n.no-authorized-template .badges {\n  text-align: center;\n  margin: 50px 0px 50px 0px; }\n  .no-authorized-template .badges__link {\n    margin: 0px 25px 0px 25px; }\n  .no-authorized-template .badges__link:hover img {\n    cursor: pointer; }\n\n.no-authorized-template__contact ul {\n  list-style-type: none;\n  padding-left: 25px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./src/style/routes/not-authorized.scss
// module id = 1226
// module chunks = 49